export default {"src":"/_next/static/media/culture.cb816e4d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};